import avatar from "../Images/avatar.png";
import useScroll from "../Models/Scroll";
import React, { useState, useEffect, useCallback, useRef } from "react";
import Icon from "@mdi/react";
import {
  mdiGithub,
  mdiGitlab,
  mdiLinkedin,
  mdiClipboardAccount,
  mdiCodeArray,
  mdiBriefcase,
  mdiViewGridPlus,
  mdiDownload,
} from "@mdi/js";
import axios from "axios";
import { gsap } from "../animations/gsap";
import { useLoadingContext } from "../context/LoadingContext";
import "../CSS/Main.css";

const apiUrl = process.env.REACT_APP_API_URL;
const pdfUrl = `${process.env.REACT_APP_API_URL}getPDF`;

function Main() {
  const { preloaderDone } = useLoadingContext();
  const [about, setAbout] = useState({ about: "" });
  const avatarRef = useRef(null);
  const nameRef = useRef(null);
  const rolRef = useRef(null);
  const datesRef = useRef(null);
  const navRef = useRef(null);
  const socialRef = useRef(null);

  useEffect(() => {
    axios
      .get(apiUrl + "about")
      .then((r) => setAbout(r.data[0]))
      .catch(console.error);
  }, []);

  useEffect(() => {
    if (!preloaderDone) return;
    /*
    const tl = gsap.timeline({ defaults: { ease: "power3.out" }, delay: 0.2 });

    tl.fromTo(
      avatarRef.current,
      { scale: 0, rotation: -180, opacity: 0 },
      {
        scale: 1,
        rotation: 0,
        opacity: 1,
        duration: 1,
        ease: "elastic.out(1, 0.5)",
      },
    )
      .fromTo(
        nameRef.current,
        { x: -60, opacity: 0 },
        { x: 0, opacity: 1, duration: 0.6 },
        "-=0.3",
      )
      .fromTo(
        rolRef.current,
        { x: -60, opacity: 0 },
        { x: 0, opacity: 1, duration: 0.6 },
        "-=0.4",
      )
      .fromTo(
        datesRef.current?.children ? [...datesRef.current.children] : [],
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.5, stagger: 0.15 },
        "-=0.2",
      )
      .fromTo(
        navRef.current?.children ? [...navRef.current.children] : [],
        { x: -40, opacity: 0 },
        { x: 0, opacity: 1, duration: 0.4, stagger: 0.1 },
        "-=0.2",
      )
      .fromTo(
        socialRef.current?.children ? [...socialRef.current.children] : [],
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.5, stagger: 0.1 },
        "-=0.2",
      );

    return () => tl.kill();*/
  }, [preloaderDone]);

  const handleScroll = useCallback((SPosT) => {
    document
      .querySelector(":root")
      .style.setProperty("--progres-scroll-y", SPosT + "%");
  }, []);
  useScroll(handleScroll);

  return (
    <div className="Main">
      <div className="Main_Progress_bar"></div>
      <div className="Main_Info_basic">
        <img
          ref={avatarRef}
          src={avatar}
          alt="Main_Avatar"
          className="Main_Avatar"
          style={{ opacity: 1 }}
        />
        <div ref={nameRef} className="Main_Name" style={{ opacity: 0 }}>
          Edilson Laverde Molina
        </div>
        <div ref={rolRef} className="Main_Rol" style={{ opacity: 0 }}>
          Desarrollador Web
        </div>
      </div>
      <ul ref={datesRef} className="Main_Dates">
        <li>
          <a target="_blank" rel="noreferrer" href={pdfUrl}>
            <Icon path={mdiDownload} className="Main_Icons" size={1} />
            Descargar
          </a>
        </li>
        <li>
          <a href="mailto:edilsonlaverde_182@hotmail.com">
            <Icon path={mdiClipboardAccount} className="Main_Icons" size={1} />
            Contacto
          </a>
        </li>
      </ul>
      <ul ref={navRef} className="Main_List">
        <li>
          <a href="#about_me">
            <Icon path={mdiClipboardAccount} className="Main_Icons" size={1} />
            <p>Acerca de mi</p>
          </a>
        </li>
        <li>
          <a href="#skills">
            <Icon path={mdiCodeArray} className="Main_Icons" size={1} />
            Skills
          </a>
        </li>
        <li>
          <a href="#experience">
            <Icon path={mdiBriefcase} className="Main_Icons" size={1} />
            Experiencia
          </a>
        </li>
        <li>
          <a href="#potafolio">
            <Icon path={mdiViewGridPlus} className="Main_Icons" size={1} />
            Portafolio
          </a>
        </li>
      </ul>
      <div className="Main_Social">
        <ul ref={socialRef}>
          <li>
            <a target="_blank" rel="noreferrer" href={about.github}>
              <Icon path={mdiGithub} size={1} />
              <span> GitHub </span>
            </a>
          </li>
          <li>
            <a target="_blank" rel="noreferrer" href={about.linkedin}>
              <Icon path={mdiLinkedin} size={1} />
              <span> LinkedIn </span>
            </a>
          </li>
          <li>
            <a target="_blank" rel="noreferrer" href={about.gitlab}>
              <Icon path={mdiGitlab} size={1} />
              <span> GitLab </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
export default Main;
